export default {
    init() {
        // JavaScript to be fired on the news archive page

        $(document).ready(function(){
            let newsArchiveLoadMorebutton = $('.ed-news-load-more-button');

            $(newsArchiveLoadMorebutton).click(function(e){
                e.preventDefault();
                let newsBoxesCurrentNum = parseFloat(newsArchiveLoadMorebutton.attr('data-currentNum'));
                var i;

                for(i = newsBoxesCurrentNum; i < (newsBoxesCurrentNum + 6); i++){
                    let newsBoxToShow = $('.ed-news-single-box-' + i);
                    newsBoxToShow.show();
                    newsBoxToShow.addClass('animated fadeInUp');
                }

                // hide button if all boxes have been displayed
                let hiddenNewsBoxCount = $('.ed-news-single-box:hidden').length;

                if( hiddenNewsBoxCount <= 0 )
                    newsArchiveLoadMorebutton.hide();

                newsArchiveLoadMorebutton.attr('data-currentNum', newsBoxesCurrentNum + 6);
            });
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/news.js